import {Directive, ViewContainerRef} from "@angular/core";

@Directive({
  selector: '[paymentHost]',
})
export class PaymentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
